<template>  
  <div class="container-fluid">

  <slot v-if="loading == 0">
    <div class="row mt-2">
      <div class="col-12 text-center">
        <h4 style="color: #0E1698">Loading the Build</h4>
      </div>
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
  </slot>

  <slot v-if="loading == 1">
    <div class="row border-bottom py-2">
      <div class="col-12">
        <button @click="backToList" class="btn btn-link"><i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>Back to Build List</button>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-4 order-1 order-xl-1">

        <div class="card border-0">
          <div class="card-body">

            <div class="row">
              <div class="col-12">
                <h3 class="text-secondary text-truncate">Build Details</h3>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 border-top border-bottom">
                <h5 class="m-0 p-1 text-wrap"><span class="text-secondary">Name:</span> {{ buildDetails.build_name }}</h5>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12">
                Product: {{ buildProduct.name }}
              </div>
              <div class="col-12">
                Product PN: {{ buildProduct.part_number }}
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                Created: {{ buildDetails.created_at | moment("dddd, MMMM Do YYYY") }}
              </div>
              <div class="col-12">
                Created By: {{ buildDetails.creatorName }}
              </div>
            </div>

          </div>
        </div><!--  build section -->

        <hr class="d-block d-xl-none">
      </div>
      <div class="col-12 col-xl-5 order-3 order-xl-2">

        <div class="card border-0">
          <div class="card-body">

            <div class="row">
              <div class="col-12">
                <h3 class="text-secondary text-truncate">Build Description</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-12 border-top border-bottom d-flex justify-content-between">
                <a href="#" @click="switchIncSec(0)">Included in Product</a>
                <a href="#" @click="switchIncSec(1)">Included Options</a>
              </div>
            </div>

            <div class="row">
              <div class="col-12">

                <div v-if="incSec == 0" class="card border-0">
                  <div class="card-body">
                    <ul v-if="buildIncludes.length > 0" class="list-group border-0">
                      <li v-for="(std, index) in buildIncludes" class="list-group-item mb-1 p-1 border-0">
                        {{ std.name }}
                      </li>
                    </ul>
                    <div v-if="buildIncludes.length < 1" class="text-center mt-5">
                      <h5>No included items</h5>
                    </div>
                  </div>
                </div>

                <div v-if="incSec == 1" class="card border-0">
                  <div class="card-body">

                    <v-client-table :data="buildOptions" :columns="tableColumns2" :options="tableOptions2">
                      <div slot="price" slot-scope="props" class="">
                        {{ props.row.ext_price | currency }}
                      </div>
                    </v-client-table>

                    <!-- <v-client-table :data="buildOptions" :columns="tableColumns" :options="tableOptions">

                      <div slot="slot1" slot-scope="props" class="list-group-item mb-0 py-1 px-2">
                        <div class="mb-1"><span v-if="props.row.qty > 1">{{ props.row.qty }} x </span>{{ props.row.item_name }}</div>
                        <div class="d-flex w-100 justify-content-between">
                          <small class="mb-1">{{ props.row.item_pn }}</small>
                          <small class="text-muted">{{ props.row.ext_price | currency }}</small>
                          
                        </div>
                      </div>

                    </v-client-table> -->

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div><!--  build section -->

      </div>

      <div class="col-12 col-xl-3 order-2 order-xl-3"><!--  pricing section -->
        <div class="card border-0">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h3 class="text-secondary">Pricing</h3>
              </div>


              <div class="col-12">
                <div class="card border-top border-bottom-0 border-right-0 border-left-0 mb-0">
                  <div class="card-body pb-0">
                    <div class="row">
                      <div class="col-12">
                        <h5>Base Price</h5>
                      </div>
                      <div class="col-12">
                        {{ buildProduct.part_number}} {{ buildProduct.name}}
                      </div>
                      <div class="col-12 text-right">
                        {{ buildDetails.base_price | currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="card border-top border-bottom border-left-0 border-right-0 mb-0">
                  <div class="card-body pb-0">
                    <div class="row">
                      <div class="col-12">
                        <h5>Optionals Price</h5>
                      </div>
                      <div class="col-12">
                        {{ buildOptions.length}} x Optionals
                      </div>
                      <div class="col-12 text-right">
                        {{ buildDetails.opt_price | currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="card border-top border-bottom border-left-0 border-right-0">
                  <div class="card-body pb-0">
                    <div class="row">
                      <div class="col-12">
                        <h5>Subtotal</h5>
                      </div>
                      <div class="col-12 text-right">
                        {{ buildDetails.tot_price | currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="d-block d-xl-none">
      </div>
    </div>

  </slot>

  </div><!--  end container-fluid div -->
</template>

<style>

</style>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../stores/product-builder-main-store.js'

/*
prop3 =
  [0] = nothing
  [1] = id of build
*/

export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loading: '0',
      incSec: '1',
      buildDetails: [],
      buildProduct: [],
      buildIncludes: [],
      buildOptions: [],
      tableColumns: ['slot1'],
      tableColumns2: ['item_pn', 'item_name', 'price'],
      tableOptions2: {
        skin: 'table table-sm border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 12,
        theme: 'bootstrap4',
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          item_pn: 'd-none d-lg-block',
          item_name: '',
          price: '',
        }, 
        headings: { 
          item_pn: 'PN',
          item_name: 'Item',
          price: 'Price',
        },
        
      },
      tableOptions: {
        skin: 'table table-sm border-0 nohead vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 8,
        theme: 'bootstrap4',
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          slot1: '',
        }, 
        headings: { 
          slot1: '',
        },

      }
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.getBuildInformation();
  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },
    getBuildInformation() {
      var _this = this;
      _this.loading = 0;
      axios.get('/builder/utility/build/getspecificbuild/' + _this.prop3[1])
        .then(function (response) {
          var a = response.data.data;
          console.log(a);
          _this.buildDetails = response.data.data;
          _this.buildProduct = _this.buildDetails.product;
          _this.buildIncludes = _this.buildDetails.product.includes;
          _this.buildOptions = _this.buildDetails.options;
          _this.loading = 1;
        });
    },
    switchIncSec(x) {
      var _this = this;
      if(_this.incSec == x) { return false; } else { _this.incSec = x; }
    },
    backToList() {
      var _this = this;
      _this.$emit('onUComplete', ['product-view']);
    }
  },    
  components:{
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>
